<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        v-bind:style="{ zIndex: 200 }"
    >
        <v-card>
            <v-card-title class="headline">
                Ship Later Date # {{ orderId }}
            </v-card-title>

            <v-card-text>
                <p class="text-h5 text-center">{{ shipLaterDate }}</p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="hide">
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as data from '@/data/index';

export default {
    data: () => {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            orderId: '',
            shipLaterDate: ''
        };
    },
    mounted() {},
    methods: {
        show(order) {
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
                
                const shipLaterDate = data.orders.getOrderShipLaterDate(order);
                if (!shipLaterDate || shipLaterDate === '') {
                    this.resolve(true);
                    this.dialog = false;
                    return;
                }
                
                this.orderId = order.order.id;
                this.shipLaterDate = shipLaterDate;
                this.dialog = true;
            });
        },

        hide() {
            this.resolve(true);
            this.dialog = false;
            this.shipLaterDate = '';
        }
    }
};
</script>
